const $ = require('jquery');
require('slick-carousel');

var selector = '.js-header-carousel',
    $elem = $(selector);

function init() {

    if (!$elem.length) {
        return false;
    }

    const customCSSElement = $('style#carouselStyles');
    const globalHeader = $('#global-header');

    const slideChange = (event, slick, currentSlide) => {
        const slide = slick.$slides.get(currentSlide);
        const jsonData = $(slide).find('script').text();
        if (jsonData) {
            const data = JSON.parse(jsonData);
            const newCSS = [
                `.slick-dots li button { border-color: ${data.textColour} }`,
                `.slick-dots li.slick-active button { background-color: ${data.textColour}}`,
            ];
            customCSSElement.text(newCSS.join(''));

            globalHeader.removeClass((index, className) => {
                const matches = className.match(/global-header--\w+/);
                return matches && matches.length ? matches[0] : false;
            });
            if (data.navigationOptions && data.navigationOptions.length) {
                globalHeader.addClass(`global-header--${data.navigationOptions}`)
            }
        }
    };

    $elem.on('afterChange', slideChange);

    $elem.slick({
        autoplay: true,
        autoplaySpeed: 7000,
        arrows: false,
        dots: true,
    });
}

module.exports = {
    init: init
}



// WEBPACK FOOTER //
// ./modules/headerCarousel.js